export default {"src":"/_next/static/media/break.511dd021.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};